import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatIconRegistry } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { regExps, errorMessages, OapErrorMessages, OapStandarErrorStateMatcher, ConfirmValidParentMatcher, CustomValidatorsModule } from '../../custom-validators/custom-validators.module';
import { first } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import {TrackingService} from '../../../services/tracking.service';
import { AlertService } from 'src/app/services/alert.service';
import { CompteService } from 'src/app/services/compte.service';

export interface DialogData {
  expired: boolean;
}

@Component({
  selector: 'oap-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  changePasswordForm: FormGroup;
  checkPasswordForm: FormGroup;
  showCancelButton = true;
  submitted = false;
  errors = errorMessages;
  validation_messages = OapErrorMessages;
  matcher = new OapStandarErrorStateMatcher();
  confirmValidParentMatcher = new ConfirmValidParentMatcher();

  tooltip_title = 'Changement de mot de passe';
  inputTypePassword = 'password';
  inputTypeCheckPassword = 'password';
  tooltip_password = 'Voir le mot de passe';
  inputTypeConfirmPassword = 'password';
  tooltip_confirm_password = 'Voir le mot de passe';
  showInformation = false;
  info = "C'est votre première connexion ou votre mot de passe a expiré, veuillez changer de mot de passe.";

  compteKey: number;

  showChangePassword = false;

  constructor(public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    private compteService: CompteService,
    private alertService: AlertService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private tracking: TrackingService) {
      iconRegistry.addSvgIcon('eye', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-remove_red_eye-24px.svg'));
      iconRegistry.addSvgIcon('saveAs', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-save_alt-24px.svg'));
    }


  ngOnInit() {
    const authToken = JSON.parse(localStorage.getItem('currentUser'));
    this.compteKey = authToken.id;
    if (this.data.expired) {
      this.showInformation = true;
      this.showCancelButton = false;
      this.showChangePassword = true;
    } else {
      this.showChangePassword = false;
    }

    this.changePasswordForm = this.formBuilder.group({
      matchingPassword : this.formBuilder.group({
        password: ['', [Validators.required,
          Validators.pattern(regExps.password),
          Validators.maxLength(100)
          ]],
        confirmPassword: ['', Validators.required]
        }, {
         validator: (formGroup: FormGroup) => {
             const ret =  CustomValidatorsModule.areEqual(formGroup);
             return ret;
        }
      })
    });

    this.checkPasswordForm = this.formBuilder.group({
      checkPassword : this.formBuilder.group({
      password: ['', [Validators.required,
        Validators.maxLength(100)
        ]],
      })
    });

  }

  toggleViewPassword() {
    if (this.inputTypePassword === 'password') {
      this.inputTypePassword = 'text';
      this.tooltip_password = 'Cacher le mot de passe';
    } else {
      this.inputTypePassword = 'password';
      this.tooltip_password =  'Voir le mot de passe';
    }
  }

  toggleViewCheckPassword() {
    if (this.inputTypeCheckPassword === 'password') {
      this.inputTypeCheckPassword = 'text';
      this.tooltip_password = 'Cacher le mot de passe';
    } else {
      this.inputTypeCheckPassword = 'password';
      this.tooltip_password =  'Voir le mot de passe';
    }
  }

  toggleViewConfirmPassword() {
    if(this.inputTypeConfirmPassword === 'password') {
      this.inputTypeConfirmPassword = 'text';
      this.tooltip_confirm_password = 'Cacher le mot de passe';
    } else {
      this.inputTypeConfirmPassword = 'password';
      this.tooltip_confirm_password = 'Voir le mot de passe';
    }
  }

  onSubmit(form: FormGroup) {
    this.submitted = true;
    // stop here if form is invalid
    if (this.changePasswordForm.invalid) {
        return;
    }

    this.alertService.clear();

    this.compteService.updatePassword(form.controls.matchingPassword.value.password, this.compteKey)
    .pipe(first())
    .subscribe(
      data => {
          this.alertService.success('Mot de passe mis à jour avec succès', false);
          return this.dialogRef.close();
      },
      error => {
        this.alertService.error(error, false);
      });

    this.tracking.pushDataLayer('Mot de passe', 'Click', 'Validation');

    //return this.dialogRef.close();
  }

  onSubmitCheckPassword(form: FormGroup) {
    this.submitted = true;
    // stop here if form is invalid
    if (this.checkPasswordForm.invalid) {
        return;
    }

    this.alertService.clear();

    this.compteService.checkPassword(form.controls.checkPassword.value.password, this.compteKey)
    .pipe(first())
    .subscribe (
      data => {
        if (data.valid === true) {
          this.showChangePassword = true;  
        } else {
          this.alertService.error("Le mot de passe saisi ne cosrrespond pas à votre mot de passe actuel.", false);  
        }
      },
      error => {
        this.alertService.error(error, false);
      });
  }

  closeTracking() {
    console.log('Clear alerte');
    this.alertService.clear();
    this.tracking.pushDataLayer('Mot de passe', 'Click', 'Abandon');
  }
  
  closeDialog() {
    return this.dialogRef.close();
  }

}
